








import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Editor as TipTapViewer, Text } from 'tiptap';
import { EnterBreakNode, InputDocNode, MergeValueNode, ParagraphNode } from '@/editor/tiptap/nodes';
import { Bold, Italic, Underline } from '@/editor/tiptap/marks';
import { Focus, History } from '@/editor/tiptap/plugins';
import { ProsemirrorViewerRoot } from '@/editor/editor-block-view/components/mixins/prosemirror-viewer-root';
import { ENodeAlign, EProsemirrorType } from '@/editor/types/enums';
import { ITextContentDoc } from '@/editor/types';
import ProsemirrorWrapper from '@/editor/editor-block/components/ProsemirrorWrapper.vue';
import { ProsemirrorHelper } from '@/editor/helpers/prosemirror.helper';

@Component({
  components: {
    ProsemirrorWrapper,
  },
})
export default class ProsemirrorViewerFormInput extends Mixins(ProsemirrorViewerRoot) {
  @Prop() content: ITextContentDoc;
  @Prop({ default: true }) multiLine: boolean;
  @Prop({ default: true }) bold: boolean;
  @Prop({ default: true }) italic: boolean;
  @Prop({ default: true }) underline: boolean;
  @Prop({ default: true }) label: boolean;
  @Prop({ default: false }) fieldFocused?: boolean;
  @Prop({ default: false }) editable: boolean;
  @Prop({ default: '' }) placeholder: string;
  @Prop() initials: string;
  @Prop() color: string;

  @Watch('fieldFocused')
  watchFieldFocused(fieldFocused: boolean) {
    if (fieldFocused) {
      this.viewer.focus();
    }
  }

  get inputViewer() {
    return {
      content: this.content,
      useBuiltInExtensions: false,
      editable: this.editable,
      extensions: [
        new InputDocNode(),
        new Focus(),
        new ParagraphNode({ defaultAlign: ENodeAlign.Left }),
        new Text(),
        new MergeValueNode(),
        new History(),
        ...(this.bold ? [new Bold()] : []),
        ...(this.italic ? [new Italic()] : []),
        ...(this.underline ? [new Underline()] : []),
        ...(this.multiLine ? [new EnterBreakNode()] : []),
      ],
      emptyDocument: {
        type: EProsemirrorType.Doc,
        content: [
          {
            type: EProsemirrorType.Paragraph,
          },
        ],
      },
      onBlur: this.update,
      onInit: this.handleInit,
      dropCursor: {
        color: 'transparent',
      },
    };
  }

  get innerTextContent(): string {
    let transaction = this.viewerState.tr;

    transaction = ProsemirrorHelper.replaceBrNodes(transaction, this.viewerState.schema);

    return ProsemirrorHelper.getStringFromTransaction(transaction, this.viewerState.schema);
  }

  update() {
    if (!this.editable) {
      return;
    }

    this.$emit('update', this.innerTextContent);
  }

  mounted() {
    this.viewer = new TipTapViewer(this.inputViewer);
  }

  beforeDestroy() {
    this.viewer.destroy();
  }
}
